import gql from "graphql-tag";

export default gql`
  mutation SignUpFromGoogleOAuthAccessToken($accessToken: String!) {
    signUpFromGoogleOAuthAccessToken(accessToken: $accessToken) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
